import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import ChatWidget from './ChatWidget'
import { OpenTelemetryManager } from '@measurement/opentelemetry-web'
import { openTelemetryConfig } from './apiConfig'

const mountPoint =
  (window as any).CHAT_WIDGET_MOUNT_POINT || document.getElementById('root')

if (!mountPoint) {
  throw new Error('Failed to find mounting point for chat widget')
}

const root = ReactDOM.createRoot(mountPoint)
OpenTelemetryManager.initialize(openTelemetryConfig)
root.render(
  <React.StrictMode>
    <ChatWidget />
  </React.StrictMode>,
)
